import {
  HttpErrorResponse,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { PLATFORM_ID } from '@angular/core';
import {
  AnalyticsService,
  ApplicationName,
  Configurable,
  InterceptorConfig,
  ModalPageMap,
  PendingPayloadsService,
  SiteName,
} from '@rogers/analytics';

import { AnalyticsPayloadService } from 'src/app/services/analytics-payload.service';

export function analyticsFactoryService(
  analyticsPayloadService: AnalyticsPayloadService,
  pendingPayloadsService: PendingPayloadsService,
  siteName: SiteName,
  appName: ApplicationName
) {
  const configuration = new Configurable();
  configuration.language = analyticsPayloadService.language;
  configuration.province = analyticsPayloadService.province;
  configuration.personalization = analyticsPayloadService.personalization;
  /* istanbul ignore next */
  const modalOpenListener: ModalPageMap = () => ''; // RCH is not using this listener as no modal open event is emitted

  const analyticsService = new AnalyticsService(
    configuration,
    siteName,
    {},
    pendingPayloadsService,
    appName,
    modalOpenListener,
    PLATFORM_ID
  );

  analyticsService.interceptorConfigs = [
    {
      shouldInterceptRequest: (req: HttpRequest<any>) =>
        // Currently we don't track any requests
        false,
      requestInterceptor: (req: HttpRequest<any>) => {
        // Currently we don't track any requests
      },
      shouldInterceptResponse: (
        req: HttpRequest<any>,
        resp: HttpResponse<any>
      ) =>
        // Currently we don't track any success response, error responses are tracked in errorHandler
        false,
      responseInterceptor: (req: HttpRequest<any>, resp: HttpResponse<any>) => {
        // Currently we don't track any success response, error responses are tracked in errorHandler
      },
      shouldHandleError: (req: HttpRequest<any>, err: HttpErrorResponse) =>
        // All error responses are tracked
        true,
      // log an error beacon when above shouldHandleError is true
      errorHandler: (req: HttpRequest<any>, err: HttpErrorResponse) => {
        analyticsPayloadService.handleApiErrors(req, err);
      },
    },
  ] as InterceptorConfig[];

  return analyticsService;
}

export function AnalyticsServiceWrapper(analyticsService: AnalyticsService) {
  return analyticsService;
}
